<template>
    <a class="market-position-overview">
        <SectionTitle :title="$t('market_position_overview')" :subtitle="`${$t('profit_ratio')} ${profitRatio}%`">
            <div class="market-position-overview__data">
                <DataItem :value="formatNumber(support)" :label="$t('support')" />
                <DataItem :value="formatNumber(avgCost)" :label="$t('avg_cost')" />
                <DataItem :value="formatNumber(resistance)" :label="$t('resistance')" />
            </div>
        </SectionTitle>
    </a>
</template>

<script >
import SectionTitle from '../../assets/uis/containers/SectionTitle.vue';
import DataItem from '../../assets/uis/DataItem.vue';
import { LanguageId, useI18n } from '../../common/useI18n';
const __sfc_main = {};
__sfc_main.props = {
  profitRatio: {
    type: Number,
    default: 0
  },
  support: {
    type: Number,
    default: 0
  },
  avgCost: {
    type: Number,
    default: 0
  },
  resistance: {
    type: Number,
    default: 0
  },
  languageId: {
    type: Number,
    default: LanguageId.EN
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // 多语言
  const $t = useI18n(props.languageId);

  // 格式化数字
  const formatNumber = num => {
    return num.toFixed(3);
  };
  return {
    $t,
    formatNumber
  };
};
__sfc_main.components = Object.assign({
  SectionTitle,
  DataItem
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.market-position-overview {
    padding: 0.3rem 0 0.4rem;
    display: block;

    &__data {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
}
</style>
